const Path = Object.freeze({
  ORDERS: "/order",
  ORDER_OVERVIEW: "/order/:uuid",
});

export { Path };
